<template>
    <input type="number" v-model="content"  @focus="onFocus" @blur="onBlur" />
</template>

<script>
    export default {
        props: ['value', 'allow_empty'],
        data() {
            return {
                content: this.value,
                focusing: false,
            };
        },
        mounted() {
            var id = uniqid();
            $(this.$el).attr("id", id);
            var parent = $(this.$el).parent();

            parent.prev().attr("for", id);
            parent.next().attr("id", id+"-message");
        },
        watch: {
            content(val){
                this.$emit('input', val);
            },
            value(val){
                this.content = val;
            }

        },
        methods: {
            onFocus(e) {
                if (parseFloat(this.content) == 0) {
                    this.focusing = true;
                    this.content = null;
                    this.focusing = false;
                    return;
                }

                e.target.select();
            },
            onBlur() {
                if (this.content == null || this.content == '') {
                    this.focusing = true;
                    this.content = this.allow_empty ? '' : 0;
                    this.focusing = false;
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/number.vue